import { Outlet,useLocation, useSearchParams } from 'react-router-dom';

import { AuthPageLayout } from '@ekhodealer/ekho-common/auth-client';
import { SteppedProgressBar } from '@ekhodealer/ekho-common/rev';

// Step labels mirror NEW_DEALER_STEPS in product-onboarding atoms — keep in sync if changed
const NEW_DEALER_STEPS = ['Dealer Info', 'Products', 'Payment', 'Processing', 'Setup', 'Verify Email'] as const;

function getOnboardingStepIndex(pathname: string): number {
	if (pathname.includes('verify-email')) return 5;
	return 4; // /setup/profile
}

export default function SetupLayout() {
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const isFromOnboarding = searchParams.get('from') === 'onboarding';

	return (
		<AuthPageLayout showPoweredBy={false}>
			{isFromOnboarding && (
				<SteppedProgressBar
					steps={[...NEW_DEALER_STEPS]}
					currentStepIndex={getOnboardingStepIndex(location.pathname)}
					showLabels={false}
				/>
			)}
			<Outlet />
		</AuthPageLayout>
	);
}
